/**
 * seedForCreate — parent_id/is_group seed for a new record in a hierarchical
 * (parent_id/is_group) catalog, derived from the Create menu's chosen kind
 * (Group|Element) and the currently selected tree row.
 *
 * Owner rule (2026-07-30, element hierarchy): the selected node — group OR
 * element — becomes the new record's parent ("the system knows where you
 * are"). Selecting 5200 and creating puts the record UNDER 5200; to create a
 * sibling, select the parent node instead. Nothing selected → root.
 *
 * Extracted from RuntimeListView (already large) so the pure seeding rule is
 * unit-testable without mounting the list view.
 */
export type HierarchyCreateKind = 'group' | 'element'

export function seedForCreate(
  kind: HierarchyCreateKind,
  selected: Record<string, unknown> | null,
): Record<string, unknown> {
  return {
    is_group: kind === 'group',
    parent_id: selected ? (selected.id ?? null) : null,
  }
}
